import { StyleSheet } from "react-native";

const OFFERING_CONTENT_STICKY_TOP = 48;

const style = StyleSheet.create({
  content: {
    flex: 1,
  },
  header: {
    zIndex: 1,
  },
});

export { style, OFFERING_CONTENT_STICKY_TOP };
